<template>
  <main class="account-main">
    <div class="form">
      <h1 class="text-phaneroo-400 text-2xl font-bold">Complete your signup</h1>
      <!-- <p class="text-orange-400 text-xl">
        Complete signup for
        <span class="px-3 py-2 bg-orange-100 text-orange-600">
          {{ email }}
        </span>
      </p> -->

      <form class="form my-8">
        <!-- TODO: add validation with Vuelidate -->
        <b-field label="First name">
          <b-input
            v-model="firstName"
            type="text"
            placeholder="First name"
            maxlength="30"
          />
        </b-field>
        <b-field label="Last name">
          <b-input
            v-model="lastName"
            type="text"
            placeholder="Last name"
            maxlength="30"
          />
        </b-field>
        <b-field label="Password">
          <b-input
            v-model="password"
            type="password"
            password-reveal
          />
        </b-field>
        <b-field label="Confirm Password">
          <b-input
            v-model="confirmPassword"
            type="password"
            password-reveal
          />
        </b-field>

        <b-button
          icon-left="user-plus"
          type="is-primary"
          class="mt-8 is-medium"
          expanded
          @click="signup"
        >
          Complete Signup
        </b-button>
        <router-link
          class="text-center block mt-6 text-phaneroo-400 underline"
          :to="{ path: '/admin/login'}"
        >
          I already have an account.
        </router-link>
      </form>
    </div>
  </main>
</template>

<script>
import { generateIdenticon } from '../../components/renderless/avatar-generator'
import { $axios } from '../../utils'

export default {
  name: 'CompleteSignup',
  data () {
    return {
      firstName: '',
      lastName: '',
      password: '',
      confirmPassword: ''
      // agreeTermsOfService: false
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    }
  },
  methods: {
    /**
     * Dispatches signup action
     */
    async signup () {
      const user = {
        firstName: this.firstName,
        lastName: this.lastName,
        password: this.password,
        confirmPassword: this.confirmPassword
      }

      try {
        await $axios('/auth/completesignup', {
          method: 'POST',
          headers: {
            'x-signup-token': this.token
          },
          data: user
        })

        try {
          // Process default avatar
          const avatarBase64 = generateIdenticon()
          const res = await fetch(avatarBase64)
          const avatar = await res.blob()
          const fd = new FormData()
          const file = new File([avatar], `${user.firstName}_${user.lastName}_avatar.jpeg`)
          fd.append('avatar', file)

          await this.$store.dispatch('users/updateAvatar', {
            userId: user.id,
            formData: fd
          })
        } catch (error) {
          this.$logger.error('Could not create avatar', error)
          this.$sentry.captureException(error)
        }

        this.$router.push('/dashboard')
      } catch (error) {
        this.$sentry.captureException(error)
        this.$notify(error.response.data.message, {
          type: 'error'
        })
        this.$logger.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.account-main {
  @apply flex flex-col justify-center items-center;
  min-height: calc(100vh - 52px);
  margin-top: 100px;

  .form {
    width: 400px;
  }
}

@media(max-width: 768px) {
  .account-main {
    @apply pt-8;

    .form {
      width: 300px;
    }
  }
}
</style>
